import {configureStore} from '@reduxjs/toolkit';
import latestSermonReducer from './slices/latestSermonSlice';

const store = configureStore({
  reducer: {
    latestSermon: latestSermonReducer,
  },
});

export default store;